// import * as Constants from './constants.js';
import * as ExternalLogos from './externals.js';

const POLISH_LOGOS_CONSTANTS = {
	ALIOR: 'alior',
	BLIK: 'blik',
	BNP_PARIBAS: 'bnpparibas',
	BOS: 'bos',
	BS: 'bs',
	BSPB: 'bspb', // was it missing before,
	BZWBK: 'bzwbk',
	CITI: 'citi',
	CREDITAGRICOLE: 'creditagricole',
	ENVELO: 'envelo',
	GETIN: 'getin',
	IDEA_BANK: 'ideabank',
	ING: 'ing',
	INTELIGO: 'inteligo',
	IPKO: 'ipko',
	MILLENNIUM: 'millennium',
	M_TRANSFER: 'mtransfer',
	NOBLE: 'noble',
	PBS: 'pbs',
	PEKAO24: 'pekao24',
	PLUS_BANK: 'plusbank',
	POCZTOWY: 'pocztowy'
};
const LOGO_MAPPING = {
	[POLISH_LOGOS_CONSTANTS.ALIOR]: ExternalLogos.LogoAlior,
	[POLISH_LOGOS_CONSTANTS.BLIK]: ExternalLogos.LogoBlikColor,
	[POLISH_LOGOS_CONSTANTS.BNP_PARIBAS]: ExternalLogos.LogoBnpparibas,
	[POLISH_LOGOS_CONSTANTS.BOS]: ExternalLogos.LogoBos,
	[POLISH_LOGOS_CONSTANTS.BS]: ExternalLogos.LogoBs,
	[POLISH_LOGOS_CONSTANTS.BSPB]: ExternalLogos.LogoBankSelectBSPB, // seems wrong logo
	[POLISH_LOGOS_CONSTANTS.BZWBK]: ExternalLogos.LogoBzwbk,
	[POLISH_LOGOS_CONSTANTS.CITI]: ExternalLogos.LogoCiti,
	[POLISH_LOGOS_CONSTANTS.CREDITAGRICOLE]: ExternalLogos.LogoCreditAgricole,
	[POLISH_LOGOS_CONSTANTS.ENVELO]: ExternalLogos.LogoEnvelo,
	[POLISH_LOGOS_CONSTANTS.GETIN]: ExternalLogos.LogoGetin,
	[POLISH_LOGOS_CONSTANTS.IDEA_BANK]: ExternalLogos.LogoIdeabank,
	[POLISH_LOGOS_CONSTANTS.ING]: ExternalLogos.LogoING,
	[POLISH_LOGOS_CONSTANTS.INTELIGO]: ExternalLogos.LogoBankSelectInteligo,
	[POLISH_LOGOS_CONSTANTS.IPKO]: ExternalLogos.LogoIpko,
	[POLISH_LOGOS_CONSTANTS.MILLENNIUM]: ExternalLogos.LogoMillennium,
	[POLISH_LOGOS_CONSTANTS.M_TRANSFER]: ExternalLogos.LogoMtransfer,
	[POLISH_LOGOS_CONSTANTS.NOBLE]: ExternalLogos.LogoNoble,
	[POLISH_LOGOS_CONSTANTS.PBS]: ExternalLogos.LogoPbs,
	[POLISH_LOGOS_CONSTANTS.PEKAO24]: ExternalLogos.LogoBankSelectPekao24,
	[POLISH_LOGOS_CONSTANTS.PLUS_BANK]: ExternalLogos.LogoPlusbank,
	[POLISH_LOGOS_CONSTANTS.POCZTOWY]: ExternalLogos.LogoPocztowy
};
export { LOGO_MAPPING, POLISH_LOGOS_CONSTANTS };
